<template>
  <div class="supplier_binding">
    <div class="supplier_binding_content">
      <div>
        <label>编号：</label>
        <input type="text" v-model="num" title="供应商编号" disabled>
      </div>
      <div>
        <label>名称：</label>
        <input type="text" v-model="name" title="供应商名称" disabled>
      </div>
      <div>
        <label>登录账号：</label>
        <input type="text" v-model="loginNum" title="供应商登录账号" disabled>
      </div>
      <div class="supplier_binding_content_address">
        <label>公司地址：</label>
        <textarea name="公司地址" v-model="companyAddress" title="供应商公司地址" disabled></textarea>
      </div>
      <div class="supplier_binding_content_btn">
        <button class="btn_normal mr20" @click="ctrlBtn('bindingSupplier', null)">进行供应商绑定</button>
        <button class="btn_cancel" @click="ctrlBtn('removeBinding', null)">解除供应商绑定</button>
      </div>
    </div>

    <!--弹出框-->
    <supplier-binding-embed-msg v-if="isShow"
                         :title="dialogTitle"
                         :show-type="showType"
                         :supplier-msg="supplierMsg"
                         @cancelbtn="getSelectDialogEmbed"></supplier-binding-embed-msg>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="'NOP'"></loading-dialog>
  </div>
</template>

<script type="es6">
  // import SelectDialogEmbed from '../../public-component/select-dialog-embed';
  import SupplierBindingEmbedMsg from './supplier-binding-embed-msg';
  import MsgDialog from '../../public-component/msg-dialog';
  import LoadingDialog from '../../public-component/loading-dialog';

  export default {
    name: 'supplier-binding',
    // components: {SelectDialogEmbed, LoadingDialog},
    components: {SupplierBindingEmbedMsg, MsgDialog, LoadingDialog},
    data() {
      return {
        num: '', // 编号
        name: '', // 名称
        loginNum: '', // 登陆账号
        companyAddress: '', // 公司地址
        isLoading: false, // 是否显示加载框
        isShow: false, // 弹出框显示
        dialogTitle: '', // 弹出框头部名
        showType: '', // 弹出框显示内容
        supplierMsg: '', // 供应商信息
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '' // 信息框内容
      }
    },
    methods: {
      // 分销商绑定供应商数据——获取绑定的供销商
      getBindSupplier() {
        this.isLoading = true;
        this.$axios.post(this.Global.getBindSupplier, null).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            clearTimeout(timer);
            if (res.data) {
              if (!res.data.errorMsg.length) {
                if (res.data.resData) {
                  self.num = res.data.resData.SupplierCode;
                  self.name = res.data.resData.SupplierName;
                  self.loginNum = res.data.resData.LoginName;
                  self.companyAddress = res.data.resData.Address;
                } else {
                  self.num = '';
                  self.name = '';
                  self.loginNum = '';
                  self.companyAddress = '';
                }
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500);
        });
      },

      // 操作按钮
      ctrlBtn(type, msg) {
        this.isShow = true;
        this.showType = type;
        this.supplierMsg = msg;
        switch (type) {
          case 'bindingSupplier':
            this.dialogTitle = '绑定供应商';
            break;
          case 'removeBinding':
            this.dialogTitle = '提示';
            break;
        }
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
        if (e.handleType) {
          this.getBindSupplier();
        }
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      }
    },
    created() {
      this.getBindSupplier();
    },
    beforeRouteLeave(to, from, next) {
      to.meta.keepAlive = true;
      next();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/base-color";
  @import "../../../assets/css/home-view";

  .supplier_binding {
    .supplier_binding_content {
      padding-top: 30px;

      &>div {
        margin: 0 0 20px 40px;
        label {
          display: inline-block;
          width: 100px;
          text-align: right;
        }

        input {
          width: 269px;
        }

        textarea {
          width: 458px;
          height: 137px;
        }

        &.supplier_binding_content_address {
          display: flex;
          justify-content: left;
          align-items: center;
        }

        &.supplier_binding_content_btn {
          width: 570px;
          text-align: right;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/system-based/supplier-binding.vue